import { Text } from "@wix/design-system";
import { useTranslation } from "@wix/fe-essentials-standalone";
import { useMobile } from "../../../hooks/useMobile";

export function Subtitle() {
  const { t } = useTranslation();
  const isMobile = useMobile();

  return (
    <Text size={isMobile ? "small" : "medium"} className="landing-subtitle">
      {isMobile ? t("landing.mobile.subtitle") : t("landing.subtitle")}
    </Text>
  );
}
